export default {"src":"/_next/static/media/solana_color.4dff6b14.svg","height":9,"width":12,"blurWidth":0,"blurHeight":0};